//#region Imports
import React, { useEffect, useLayoutEffect, useState, useImperativeHandle, forwardRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
//MUI
import CloseIcon from '@mui/icons-material/Close';
import DescriptionIcon from '@mui/icons-material/Description';
import { Backdrop, Box, Button, Grid, MenuItem, Select, Typography, TextField, useMediaQuery } from '@mui/material';
import AppLoader from '../../../components/AppLoader/AppLoader';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import warning from '../../../images/warning.png';
import { tableStyleOverDue } from '../../../style/common';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import InfoIcon from '@mui/icons-material/Info';
import crossIcon from "../../../images/remove.png";
import pdfIcon from "../../../images/pdfIcon.png";

//components
//scss
// import "./DueDateExtensionTable.scss"
import "../../../style/common.scss";
import "./AdjustLastBillWorkflowDialog.scss";
import {
    WORKFLOW_MOBILE_MEDIA,
    workflowDialogClassName,
    workflowDialogShellProps,
} from '../../../utils/workflowDialogShell';
//Yup
import * as Yup from "yup";
//formik

import { useFormik } from 'formik';
//urls
import { cfpBaseUrl } from '../../../network/urls';
// use scan detection
import useScanDetection from 'use-scan-detection';
import CheckPermissions from '../../../authorization/authorization';
//Services
import StepProgressBar from '../../../components/StepProgressBar/StepProgressBar';
import ProcessingSummaryTableBilling from '../../../components/processingSummaryTable/processingSummaryTableBilling';
import { tableStyle } from '../../../style/common';

import { useDispatch, useSelector } from 'react-redux';
import BasicTable from '../../../components/basicTable/basicTable';
import ServiceDashboardTables from '../../../components/ServiceDashboardTables/ServiceDashboardTables';
import Error from '../../../components/error/error';
import { SearchIndividualApplication } from '../../../network/APIs/APIs';
import { addBusinessDays, calculateRemainingBusinessDays, dBillAPI, daysBetweenDatesExcludingWeekendsAndHolidays, downloadBill, getDocumentBackGroundColor, normalizeDocumentDataUrl, numberFormatting, subdivisionName } from '../../../services/Functions';
import tickicon from "../../../images/Accept.png";

import {
    fetchPaginatedBillAdjustmentNormal,
    filterDateFrom as filterDateFromNormal,
    filterDateTo as filterDateToNormal,
    filterObjectionStatus as filterObjectionStatusNormal,
    filterProgressId as filterProgressIdNormal,
    firstPage as firstPageNormal,
    lastPage as lastPageNormal,
    nextPage as nextPageNormal,
    previousPage as previousPageNormal,
    resetDateFilter as resetDateFilterNormal,
    resetObjectionStatusFilter as resetObjectionStatusFilterNormal,
    resetProgressIdFilter as resetProgressIdFilterNormal
} from '../../../features/billingAndCollection/billAdjustmentNormalSlice';

import {
    fetchPaginatedBillAdjustmentOverdue,
    filterDateFrom as filterDateFromOverdue,
    filterDateTo as filterDateToOverdue,
    filterObjectionStatus as filterObjectionStatusOverdue,
    filterProgressId as filterProgressIdOverdue,
    firstPage as firstPageOverdue,
    lastPage as lastPageOverdue,
    nextPage as nextPageOverdue,
    previousPage as previousPageOverdue,
    resetDateFilter as resetDateFilterOverdue,
    resetObjectionStatusFilter as resetObjectionStatusFilterOverdue,
    resetProgressIdFilter as resetProgressIdFilterOverdue
} from '../../../features/billingAndCollection/billAdjustmentOverdueSlice';
import Base64Image from '../../../components/Base64Image/Base64Image';
import OpenBase64ImageInPopup from '../../../services/OpenBase64ImageInPopup';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { getInitialAdminOfficeCode } from '../../../utils/adminCompany';
import { DISCO_COMPANIES } from '../../../constants/discoCompanies';
//#endregion

const toProgressId = (val) => Number(val);

const getAdjustLastBillStepBarProgressId = (row) => {
    const progressId = toProgressId(row?.applicationProgressId);
    const objection = toProgressId(row?.objectionStatus);
    if (progressId === 1 && objection === 1) return 0;
    return progressId;
};

const getAdjustLastBillSubmittedStepComplete = (row) =>
    toProgressId(row?.applicationProgressId) >= 1;

const AdjustLastBillTable = forwardRef((props, ref) => {

    //#region initial values
    const initialValues = {
        iv_approved_no_of_days: null,
        iv_approved_due_date: null
    }
    //#endregion

    //#region get item local storage
    const { token, code: officeCode, hierarchy: officeHierarchy, userId, permissions, selectedAdminCompanyCode } = useSelector((state) => state.auth);
    const isWorkflowMobile = useMediaQuery(WORKFLOW_MOBILE_MEDIA);
    const [selectedOfficeCode, setSelectedOfficeCode] = useState(
        getInitialAdminOfficeCode(officeCode, selectedAdminCompanyCode),
    );
    const apiOfficeCode = selectedOfficeCode || officeCode;

    useEffect(() => {
        if (String(officeCode) === "10" && selectedAdminCompanyCode) {
            setSelectedOfficeCode(String(selectedAdminCompanyCode));
        }
    }, [officeCode, selectedAdminCompanyCode]);
    const subDivisions = JSON.parse(window.localStorage.getItem('subDivisions'));
    const navigate = useNavigate();
    //#endregion

    //#region states

    const [error, setError] = useState()
    const [ddeApplicationsNormal, setDdeApplicationsNormal] = useState([]);
    const [ddeApplicationsNormalToDataGrid, setDdeApplicationsNormalToDataGrid] = useState([]);
    const [dayName, setDayName] = useState('-');
    const [ddeApplicationsOverdue, setDdeApplicationsOverdue] = useState([]);
    const [ddeApplicationsOverdueToDataGrid, setDdeApplicationsOverdueToDataGrid] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [dialogRowData, setDialogRowData] = React.useState({});
    const [applicationId, setapllicationid] = React.useState('')
    const [eFileData, setEFileData] = useState([]);
    const [billAdjustmentDocuments, setBillAdjustmentDocuments] = useState([]);
    const [documentsLoading, setDocumentsLoading] = useState(false);
    const [viewBackdrop, setViewBackdrop] = useState(false);
    const [applicationSubittedPopUp, setApplicationSubmittedPopUp] = useState(false);
    const [submittedDocViewer, setSubmittedDocViewer] = useState({ open: false, image: '', name: '' });
    const [availableDays, setAvailableDays] = useState([]);
    const [actionTakenPopup, setActionTakenPopup] = useState(false);
    const [openCancelModal, setOpenCancelModal] = useState(false);

    const [flag_applicantCNICFront, setFlag_applicantCNICFront] = useState(null);
    const [flag_applicantCNICBack, setFlag_applicantCNICBack] = useState(null);
    const [flag_paidBillImageFlag, setFlag_paidBillImageFlag] = useState(null);
    const [
        applicantCNICBackObjectionRemarks,
        setApplicantCNICBackObjectionRemarks,
    ] = useState("");
    const [documnets, setDocuments] = useState({})
    const [apiPopup, setApiPopup] = useState({
        open: false,
        type: "",
        message: "",
    });
    const [resultPopup, setResultPopup] = useState(null);
    const [verifyRejectRemarks, setVerifyRejectRemarks] = useState([]);
    const tableColumnsProcessingSummary = [
        {
            header: 'Step',
            accessorKey: 'stepName',
        },
        {
            header: 'Processed By',
            accessorKey: 'processedBy',
        },
        {
            header: 'Date',
            accessorKey: 'date',
        },
        {
            header: 'Remarks',
            accessorKey: 'remarks',
        },
    ]

    const [tableDataProcessingSummary, setTableDataProcessingSummary] = useState([
        {
            stepName: 'Application Submission',
            processedBy: 'Akram',
            date: '24-Dec-2023',
            time: '02:23:19 AM',
            remarks: '-',
        },
        {
            stepName: 'Application Submission',
            processedBy: 'Akram',
            date: '24-Dec-2023',
            time: '02:23:19 AM',
            remarks: '-',
        },
        {
            stepName: 'Application Submission',
            processedBy: 'Akram',
            date: '24-Dec-2023',
            time: '02:23:19 AM',
            remarks: '-',
        },
    ])
    const dispatch = useDispatch();
    let DDStatusBarArray = [
        {
            title1: 'APPLICATION',
            title2: 'SUBMITTED',
        },
        {
            title1: 'ACTION',
            title2: 'TAKEN',
        },

    ]

    const [foundInDDE, setFoundInDDE] = useState();
    const { state } = useLocation();
    const { foundId } = state ? state : '';
    const [isReleventToUser, setIsRelevantToUser] = useState(false)
    const [
        applicantCNICFrontObjectionRemarks,
        setApplicantCNICFrontObjectionRemarks,
    ] = useState("");
    const [
        paidBillImageObjectionRemarks,
        setPaidBillImageObjectionRemarks,
    ] = useState("");
    const [copyOfApplicantCNICVerifyPopUp, setCopyOfApplicantCNICVerifyPopUp] =
        useState(false);
    const [paidBillImagePopUp, setPaidBillImagePopUp] = useState(false);
    const [owenershipDocumentVerifyPopUp, setOwenershipDocumentVerifyPopUp] =
        useState(false);
    //#endregion

    //#endregion

    const { currentPage: currentPageNormal, data: dataNormal, pageSize: pageSizeNormal, totalPages: totalPagesNormal, totalRecords: totalRecordsNormal, dateFrom: dateFromNormal, dateTo: dateToNormal, applicationProgressId: applicationProgressIdNormal, objectionStatus: objectionStatusNormal, error: errorNormal, isLoading: isLoad } = useSelector((state) => state.billAdjustmentNormalPaginated);
    const { currentPage: currentPageOverdue, data: dataOverdue, pageSize: pageSizeOverdue, totalPages: totalPagesOverdue, totalRecords: totalRecordsOverdue, dateFrom: dateFromOverdue, dateTo: dateToOverdue, applicationProgressId: applicationProgressIdOverdue, objectionStatus: objectionStatusOverdue, error: errorOverdue, isLoading: isLoadd } = useSelector((state) => state.billAdjustmentOverduePaginated);

    const handleNextPage = () => {
        dispatch(nextPageNormal());
    };

    const handleDateFromFilter = (value) => {
        if (value) {
            setViewBackdrop(true)
            dispatch(filterDateFromNormal(value))
        }
    }

    const handleDateToFilter = (value) => {
        if (value) {
            setViewBackdrop(true)
            dispatch(filterDateToNormal(value))
        }
    }

    const handleResetDateFilter = () => {
        dispatch(resetDateFilterNormal())
    }

    const handleProgressIdFilter = (value) => {
        if (value || value === 0) {
            setViewBackdrop(true)
            dispatch(filterProgressIdNormal(value))
        }
    }

    const handleResetProgressIdFilter = () => {
        dispatch(resetProgressIdFilterNormal())
    }

    const handleObjectionStatusFilter = (value) => {
        if (value || value === 0) {
            setViewBackdrop(true)
            dispatch(filterObjectionStatusNormal(value))
        }
    }

    const handleResetObjectionStatusFilter = () => {
        dispatch(resetObjectionStatusFilterNormal())
    }

    const handlePreviousPage = () => {
        dispatch(previousPageNormal());
    };

    const handleFirstPage = () => {
        dispatch(firstPageNormal());
    };

    const handleLastPage = (page) => {
      dispatch(lastPageNormal(typeof page === 'number' ? page : totalPagesNormal));
    };

    useEffect(() => {
        if ((props.showTable && currentPath == "/adjust-last-bill-table") && token) {
            dispatch(fetchPaginatedBillAdjustmentNormal({ page: currentPageNormal, pageSize: pageSizeNormal, dateFrom: dateFromNormal, dateTo: dateToNormal, applicationProgressId: applicationProgressIdNormal, objectionStatus: objectionStatusNormal, officeCode: apiOfficeCode }));
        }
    }, [currentPageNormal, pageSizeNormal, dateFromNormal, dateToNormal, applicationProgressIdNormal, objectionStatusNormal, apiOfficeCode]);

   

    useEffect(() => {
        if (dataNormal) {
            setDdeApplicationsNormal(dataNormal)
            setViewBackdrop(false)
        }
    }, [dataNormal])

    const handleNextPageOverdue = () => {
        dispatch(nextPageOverdue());
    };

    const handleDateFromFilterOverdue = (value) => {
        if (value) {
            setViewBackdrop(true)
            dispatch(filterDateFromOverdue(value))
        }
    }

    const handleDateToFilterOverdue = (value) => {
        if (value) {
            setViewBackdrop(true)
            dispatch(filterDateToOverdue(value))
        }
    }

    const handleResetDateFilterOverdue = () => {
        dispatch(resetDateFilterOverdue())
    }

    const handleProgressIdFilterOverdue = (value) => {
        if (value || value === 0) {
            setViewBackdrop(true)
            dispatch(filterProgressIdOverdue(value))
        }
    }

    const handleResetProgressIdFilterOverdue = () => {
        dispatch(resetProgressIdFilterOverdue())
    }

    const handleObjectionStatusFilterOverdue = (value) => {
        if (value || value === 0) {
            setViewBackdrop(true)
            dispatch(filterObjectionStatusOverdue(value))
        }
    }

    const handleResetObjectionStatusFilterOverdue = () => {
        dispatch(resetObjectionStatusFilterOverdue())
    }

    const handlePreviousPageOverdue = () => {
        dispatch(previousPageOverdue());
    };

    const handleFirstPageOverdue = () => {
        dispatch(firstPageOverdue());
    };

    const handleLastPageOverdue = (page) => {
      dispatch(lastPageOverdue(typeof page === 'number' ? page : totalPagesOverdue));
    };

    useEffect(() => {
        if ((props.showTable && currentPath == "/adjust-last-bill-table")) {
            if (token) {
                dispatch(fetchPaginatedBillAdjustmentOverdue({ page: currentPageOverdue, pageSize: pageSizeOverdue, dateFrom: dateFromOverdue, dateTo: dateToOverdue, applicationProgressId: applicationProgressIdOverdue, objectionStatus: objectionStatusOverdue, officeCode: apiOfficeCode }));
            }
        }
    }, [currentPageOverdue, pageSizeOverdue, dateFromOverdue, dateToOverdue, applicationProgressIdOverdue, objectionStatusOverdue, apiOfficeCode]);

    useEffect(() => {
        if (dataOverdue) {
            setDdeApplicationsOverdue(dataOverdue)
            setViewBackdrop(false)
        }
    }, [dataOverdue])

    //#region api function
    const duedateextensionapi = async (x, values) => {
        setViewBackdrop(true)
        const formattedDate = values.split("-").reverse().join("-");
        var formdata = new FormData();
        formdata.append("applicationId", applicationId);
        formdata.append("lastModifiedBy", userId);
        formdata.append("applicationProgressId", x);
        formdata.append("approvedExtendedDueDate", formattedDate);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);;
        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
        };
        await fetch(cfpBaseUrl + "dateExtention/dueDateAppProgId", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === '200') {
                    setViewBackdrop(false)
                    handleClose()
                    window.location.reload();
                } else if (result.message.startsWith('Since the month end process')) {
                    setError(result.message)
                    setViewBackdrop(false)
                } else if (result.status === '400') {
                    setError(result.message)
                    setViewBackdrop(false)
                }
            })
            .catch(() => {});
    }




    const errorCloses = () => {
        setError('')
    }

    const handleClose = () => {
        setOpen(false);
        setFlag_applicantCNICFront(null);
        setFlag_applicantCNICBack(null);
        setFlag_paidBillImageFlag(null);
        setDocuments({});
        setApiPopup({ open: false, type: '', message: '' });
        setResultPopup(null);
        setVerifyRejectRemarks([]);
    }

    const buildAlbVerifyRejectRemarks = () => {
        const items = [];
        if (flag_applicantCNICFront === -1 || flag_applicantCNICBack === -1) {
            const remarks = [applicantCNICFrontObjectionRemarks, applicantCNICBackObjectionRemarks]
                .map((value) => (value != null ? String(value).trim() : ''))
                .filter(Boolean)
                .join(' ') || '—';
            items.push({ label: "Applicant's CNIC", remarks });
        }
        if (flag_paidBillImageFlag === -1) {
            items.push({
                label: 'Paid Bill Image',
                remarks: (paidBillImageObjectionRemarks || '').trim() || '—',
            });
        }
        return items;
    };

    const albResultDialogConfig = {
        success: {
            Icon: CheckCircleIcon,
            iconClassName: 'dde-result-dialog__icon dde-result-dialog__icon--approve',
            title: 'Documents Verified',
            message: 'Documents verified.',
            showBill: true,
        },
        error: {
            Icon: HighlightOffIcon,
            iconClassName: 'dde-result-dialog__icon dde-result-dialog__icon--reject',
            title: 'Request Failed',
            showBill: false,
        },
        reject: {
            Icon: HighlightOffIcon,
            iconClassName: 'dde-result-dialog__icon dde-result-dialog__icon--reject',
            title: 'Documents Rejected',
            message: 'Documents rejected.',
            showBill: false,
        },
    };

    const activeAlbResultDialog = resultPopup
        ? albResultDialogConfig[resultPopup]
        : apiPopup.open && apiPopup.type
            ? albResultDialogConfig[apiPopup.type]
            : null;

    const activeResultMessage = resultPopup
        ? albResultDialogConfig[resultPopup]?.message
        : apiPopup.message;

    const handleCloseResultPopup = () => {
        const shouldRefresh = Boolean(resultPopup || apiPopup.open);
        setResultPopup(null);
        setVerifyRejectRemarks([]);
        setApiPopup({ open: false, type: '', message: '' });

        if (!shouldRefresh) return;

        dispatch(fetchPaginatedBillAdjustmentNormal({
            page: currentPageNormal,
            pageSize: pageSizeNormal,
            dateFrom: dateFromNormal,
            dateTo: dateToNormal,
            applicationProgressId: applicationProgressIdNormal,
            objectionStatus: objectionStatusNormal,
            officeCode: apiOfficeCode,
        }));
        dispatch(fetchPaginatedBillAdjustmentOverdue({
            page: currentPageOverdue,
            pageSize: pageSizeOverdue,
            dateFrom: dateFromOverdue,
            dateTo: dateToOverdue,
            applicationProgressId: applicationProgressIdOverdue,
            objectionStatus: objectionStatusOverdue,
            officeCode: apiOfficeCode,
        }));
        handleClose();
        setViewBackdrop(false);
    };

    const handleCloseRemarks = () => {
        setOpenCancelModal(false);
    }

    useScanDetection({
        onComplete: async (code) => {
            if (code) {
                code = code.replace(/Shift/g, '');
                const regex = /^[A-Z]{2}-\d{14,15}$/;
                if (regex.test(code)) {
                    await handleRowClick(code);
                } else {
                }
            }
        },
        minLength: 4, // EAN13
    });



    const getClassName = (x) => {
        if (x === "Pending") {
            return 'pending-button';
        }
        else if (x === "In Process") {
            return 'inprocess-button';
        }
        else if (x === "Approved") {
            return 'approved-button';
        }
        else if (x === "Objection") {
            return 'objection-button';
        }
        else if (x === "Rejected") {
            return 'rejected-button';
        }
    }

    const filterNCApp = async (applicationId) => {
        let myArray = ddeApplicationsNormal
        let totalArray = myArray.concat(ddeApplicationsOverdue)
        let itemFound = totalArray.find(item => item.applicationId === applicationId)

        if (itemFound) {
            setIsRelevantToUser(true)
        }
        else if (itemFound === undefined) {
            itemFound = await SearchIndividualApplication(token, applicationId, '16')
            if (itemFound) {
                setIsRelevantToUser(itemFound.isReleventToUser)
            }
        }
        return itemFound;
    }

    const convertDate = (dateString) => {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const date = new Date(dateString);
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    }

    const convertDatewithTime = (dateString) => {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const date = new Date(dateString);
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        const hour = date.getHours();
        const minute = date.getMinutes();
        const second = date.getSeconds();
        return `${day}-${month}-${year} ${hour}:${minute}:${second}`;
    }

    const apiToDataGridConversionNormal = () => {

        const tempArray = []
        if (ddeApplicationsNormal) {
            ddeApplicationsNormal.forEach((item) => {
                let dataGridObject = {}
                if (item.applicationId) {
                    if (item.objectionStatus === 0) {
                        dataGridObject = {
                            "applicationId": item.applicationId,
                            "creationDate": convertDate(item.creationDate),
                            //"connectionType": item.connectionType,
                            "referenceNo": item.referenceNo,
                            "name": item.applicantName,
                            "dueDate": convertDate(item.currentBillDueDate),
                            // "extendedDueDate": item.appliedExtentionOfDueDate,
                            "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                            "applicationProgressId": item.applicationProgressId,
                            "releventApplicationFlage": item.releventApplicationFlage,
                        }
                    }
                    else if (item.objectionStatus === 1) {
                        dataGridObject = {
                            "applicationId": item.applicationId,
                            "creationDate": convertDate(item.creationDate),
                            //"connectionType": item.connectionType,
                            "referenceNo": item.referenceNo,
                            "name": item.applicantName,
                            "dueDate": convertDate(item.currentBillDueDate),
                            // "extendedDueDate": item.appliedExtentionOfDueDate,
                            "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                            "applicationProgressId": item.applicationProgressId,
                            "releventApplicationFlage": item.releventApplicationFlage,
                        }
                    }
                    tempArray.push(dataGridObject)
                }
            })
        }
        else {
            const dataGridObject = {
                "applicationId": ' ',
                "connectionType": '',
                // "appliedLoad": item.appliedLoad,
                // "duration": item.duration,
                "applicantName": ' ',
                "applicantCNIC": ' ',
                "applicationStatusId": statusFunc(' '),
            }
            tempArray.push(dataGridObject)
        }
        setDdeApplicationsNormalToDataGrid(tempArray);
    }

    const apiToDataGridConversionOverdue = () => {

        const tempArray = []
        if (ddeApplicationsOverdue) {
            ddeApplicationsOverdue.forEach((item) => {
                let dataGridObject = {}
                if (item.applicationId) {
                    if (item.objectionStatus === 0) {
                        dataGridObject = {
                            "applicationId": item.applicationId,
                            "creationDate": convertDate(item.creationDate),
                            //"connectionType": item.connectionType,
                            "referenceNo": item.referenceNo,
                            "name": item.applicantName,
                            "dueDate": convertDate(item.currentBillDueDate),
                            // "extendedDueDate": convertDate(item.appliedExtentionOfDueDate),
                            "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                            "applicationProgressId": progFunc(item.applicationProgressId),
                            "releventApplicationFlage": item.releventApplicationFlage,
                        }
                    }
                    else if (item.objectionStatus === 1) {
                        dataGridObject = {
                            "applicationId": item.applicationId,
                            "creationDate": convertDate(item.creationDate),
                            //"connectionType": item.connectionType,
                            "referenceNo": item.referenceNo,
                            "name": item.applicantName,
                            "dueDate": convertDate(item.currentBillDueDate),
                            // "extendedDueDate": convertDate(item.appliedExtentionOfDueDate),
                            "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                            "applicationProgressId": progFunc(item.applicationProgressId),
                            "releventApplicationFlage": item.releventApplicationFlage,
                        }
                    }
                    tempArray.push(dataGridObject)
                }
            })
        }
        else {
            const dataGridObject = {
                "applicationId": ' ',
                "connectionType": '',
                // "appliedLoad": item.appliedLoad,
                // "duration": item.duration,
                "applicantName": ' ',
                "applicantCNIC": ' ',
                "applicationStatusId": statusFunc(' '),
            }
            tempArray.push(dataGridObject)
        }
        setDdeApplicationsOverdueToDataGrid(tempArray);
    }

    const statusFunc = (x, objection) => {
        if (x === 0) {
            return 'In Process'
        }
        else if (x === 1) {
            return 'Approved'
        }
        else if (x === -1) {
            return 'Rejected'
        }
    }

    const progFunc = (x) => {
        if (x === 0) {
            return 'Documents Uploading'
        }
        else if (x === 1) {
            return 'Documents Verification'
        }
        // else if (x === 2) {
        //     return 'Arrears Verification'
        // }
        // else if (x === 3) {
        //     return 'Field Verification'
        // }
        // else if (x === 4) {
        //     return 'Demand Note Issued'
        // }
        // else if (x === 5) {
        //     return 'DN Payment Verification'
        // }
        // else if (x === 6) {
        //     return 'Meter Installation'
        // }
        // else if (x === 7) {
        //     return 'Ready for Billing'
        // }
    }
    const formatToDDMMYYYY = (dateString) => {
        if (!dateString) return "-";

        const [year, month, day] = dateString.split("-");
        return `${day}-${month}-${year}`;
    };
    const handleRowClick = async (applicationId, event) => {
        setViewBackdrop(true);
        const item = await filterNCApp(applicationId);
        if (item) {
            setDialogRowData(item);
            setFlag_applicantCNICFront(item.applicantCNICFrontFlag);
            setFlag_applicantCNICBack(item.applicantCNICBackFlag);
            setFlag_paidBillImageFlag(item.paidBillImageFlag);
            // setFlag_electricityBillDocument(item.electricityBillFlag);

            let dataforTable = [];

            if (item.applicationProgressId === 0) {
                dataforTable.push({
                    date: convertDate(item.creationDate),
                    processedBy: item.createdBy,
                    stepName: "Application Submitted",
                    time: convertDatewithTime(item.creationDate).slice(11, 17),
                    remarks: 'Application Submitted.'
                });
            }
            else if (item.applicationProgressId === 1) {
                // Only show Application Submitted for In Process
                dataforTable.push({
                    date: convertDate(item.creationDate),
                    processedBy: item.createdBy,
                    stepName: "Application Submitted",
                    time: convertDatewithTime(item.creationDate).slice(11, 17),
                    remarks: 'Application Submitted.'
                });

            }
            else if (item.applicationProgressId === 2) {
                // Show Action Taken and Application Submitted for Completed
                dataforTable.push({
                    stepName: "Action Taken",
                    processedBy: item.lastModifiedBy || 'N/A',
                    date: item.lastModificationDate ? convertDatewithTime(item.lastModificationDate) : 'N/A',
                    remarks: item.remarks || '-',
                });

                dataforTable.push({
                    date: convertDate(item.creationDate),
                    processedBy: item.createdBy,
                    stepName: "Application Submitted",
                    time: convertDatewithTime(item.creationDate).slice(11, 17),
                    remarks: 'Application Submitted.'
                });

            }

            setTableDataProcessingSummary(dataforTable);

            setapllicationid(item.applicationId)
            await getBillAdjustmentDocuments(item.applicationId);
            setViewBackdrop(false);
            setOpen(true);
        } else {
            setViewBackdrop(false);
        }
    };

    const openDetailsPopUp = async (stepName) => {
        let id = dialogRowData.applicationId

        if (stepName === "APPLICATION SUBMITTED" || stepName === "Application Submitted") {
            setApplicationSubmittedPopUp(true);
        } else if (stepName === "ACTION TAKEN" || stepName === "Action Taken") {
            setActionTakenPopup(true);
        }
    }

    const renderSubmittedDocumentPreview = (src, alt) => {
        const normalized = normalizeDocumentDataUrl(src);
        if (!normalized) return null;

        const isPdfDocument =
            normalized.startsWith('data:application/pdf') ||
            normalized.slice(0, 6) === 'data:a';

        return isPdfDocument ? (
            <img src={pdfIcon} alt={`${alt} PDF`} />
        ) : (
            <img src={normalized} alt={alt} />
        );
    };

    const stepName = (x) => {
        if (x === 0) {
            return 'Application Submission'
        }
        else if (x === 1 || x === -1) {
            return 'Action Taken'
        }
    };

    //#endregion

    //#endregion

    //#region useEffects

    useEffect(() => {
        if (ddeApplicationsNormal) {
            apiToDataGridConversionNormal()
        }
    }, [ddeApplicationsNormal]);

    useEffect(() => {
        if (ddeApplicationsOverdue) {
            apiToDataGridConversionOverdue()
        }
    }, [ddeApplicationsOverdue]);

    useEffect(() => {
        if (foundId && foundId !== '') {
            setFoundInDDE(foundId)
        }
    }, [foundId])

    useLayoutEffect(() => {
        if (foundInDDE) {
            handleRowClick(foundInDDE)
        }
    }, [foundInDDE])

    const getDayName = (dateString) => {
        if (!dateString) return "-";

        let date;

        if (dateString.includes("-") && dateString.split("-")[0].length === 4) {
            const [year, month, day] = dateString.split("-");
            date = new Date(Number(year), Number(month) - 1, Number(day));
        } else if (dateString.includes("-")) {
            const [day, monthStr, year] = dateString.split("-");
            const month = new Date(Date.parse(monthStr + " 1, 2020")).getMonth();
            date = new Date(Number(year), month, Number(day));
        } else {
            return "-";
        }

        if (isNaN(date)) return "-";
        return date.toLocaleString("en-US", { weekday: "long" });
    };
    const formatDateToShortMonth = (dateString) => {
        if (!dateString) return "-";

        const [day, month, year] = dateString.split("-");
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        const monthIndex = parseInt(month, 10) - 1;
        if (monthIndex < 0 || monthIndex > 11) return "-";

        return `${day}-${months[monthIndex]}-${year}`;
    };


    //#endregion

    const tblColumns = [
        { field: "applicationId", headerName: 'Application No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "creationDate", type: 'dateTime', headerName: 'Submission Date', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "referenceNo", headerName: 'Reference No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "name", headerName: 'Applicant Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "dueDate", type: 'dateTime', headerName: 'Due Date', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        {
            field: "applicationProgressId",
            headerStyle: tableStyle.headerStyle,
            headerCellStyle: tableStyle.headerCellStyle,
            rowCellStyle: tableStyle.rowCellStyle,
            headerName: "Status",
            align: 'center',
            sortable: false,
            filterable: false,
            renderCell: (row) => {
                let btnText = row.applicationProgressId === 1 ? 'In Process' : row.applicationProgressId === 2 ? 'Approved' : '-';
                let textColor = row.applicationProgressId === 1 ? '#0d6efd' : row.applicationProgressId === 2 ? '#198754' : '#6c757d';
                return (
                    <div style={{
                        color: textColor,
                        fontWeight: 600
                    }}>
                        {btnText}
                    </div>
                )
            }
        },
    ]

    const tblColumnsOverDue = [
        { field: "applicationId", headerName: 'Application No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "creationDate", type: 'dateTime', headerName: 'Submission Date', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "referenceNo", headerName: 'Reference No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "name", headerName: 'Applicant Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "dueDate", type: 'dateTime', headerName: 'Due Date', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        {
            field: "applicationProgressId",
            headerStyle: tableStyleOverDue.headerStyle,
            headerCellStyle: tableStyleOverDue.headerCellStyle,
            rowCellStyle: tableStyleOverDue.rowCellStyle,
            headerName: "Status",
            align: 'center',
            sortable: false,
            filterable: false,
            renderCell: (row) => {
                let btnText = row.applicationProgressId === 1 ? 'In Process' : row.applicationProgressId === 2 ? 'Approved' : '-';
                let textColor = row.applicationProgressId === 1 ? '#0d6efd' : row.applicationProgressId === 2 ? '#198754' : '#6c757d';
                return (
                    <div style={{
                        color: textColor,
                        fontWeight: 600
                    }}>
                        {btnText}
                    </div>
                )
            }
        },
    ]

    useImperativeHandle(ref, () => ({
        handleRowClick
    }));

    const location = useLocation()
    const currentPath = location.pathname;

    const ranges = [
        { max: 25000, perm: '1 - 25,000' },
        { max: 50000, perm: '25,001 - 50,000' },
        { max: 100000, perm: '50,001 - 100,000' },
        { max: 200000, perm: '100,001 - 200,000' },
        { max: 300000, perm: '200,001 - 300,000' },
        { max: 500000, perm: '300,001 - 500,000' },
        { max: 1000000, perm: '500,001 - 1,000,000' },
        { max: 20000000, perm: '1,000,001 - 20,000,000' },
        { max: Infinity, perm: '20,000,001 - MAX' },
    ];

    const canApprove = (billAmount) => {
        let maxLimit = 0;

        for (let i = 0; i < ranges.length; i++) {
            const { max, perm } = ranges[i];

            const hasPermission = CheckPermissions(
                permissions,
                'Billing and Collection',
                'Due Date Extension',
                'Workflow Permissions',
                perm
            );

            if (hasPermission) {
                maxLimit = max;
            } else {
                break;
            }
        }

        return billAmount <= maxLimit;
    };

    const formatMonthYear = (dateString) => {
        if (!dateString) return '-';
        const cleanDateString = dateString.split('T')[0];
        const date = new Date(cleanDateString);
        if (isNaN(date)) return '-';
        const month = date.toLocaleString('en-US', { month: 'short' });
        const year = date.getFullYear();
        return `${month}-${year}`;
    };

    const isExtensionDateExpired = (dateString) => {
        if (!dateString) return false;

        const appliedDate = new Date(dateString);
        const today = new Date();


        appliedDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        return appliedDate < today;
    };



    const remarksFormik = useFormik({
        initialValues: {
            iv_remarks: "",
            // Add iv_approved_due_date if it’s part of the form
            // iv_approved_due_date: "",
        },
        validationSchema: Yup.object({
            iv_remarks: Yup.string()
                .min(10, "Remarks should be at least 10 characters.")
                .max(100, "Remarks should be less than 100 characters.")
                .required("Enter remarks."),
            // Add validation for iv_approved_due_date if needed
            // iv_approved_due_date: Yup.string().required("Date is required."),
        }),
        onSubmit: async (values) => {
            const x = -1;
            const formattedDate = dialogRowData.appliedExtentionOfDueDate
            setViewBackdrop(true);
            try {
                const formdata = new FormData();
                //   formdata.append("remarks", values.iv_remarks); 
                formdata.append("applicationId", applicationId);
                formdata.append("lastModifiedBy", userId);
                formdata.append("applicationProgressId", x);
                formdata.append("approvedExtendedDueDate", formattedDate);
                const myHeaders = new Headers();
                myHeaders.append("Authorization", token);
                const requestOptions = {
                    method: 'POST',
                    body: formdata,
                    headers: myHeaders,
                    redirect: 'follow',
                };
                await fetch(cfpBaseUrl + "dateExtention/dueDateAppProgId", requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        if (result.status === '200') {
                            setOpenCancelModal(false);
                            handleClose();
                        } else if (result.message?.startsWith('Since the month end process')) {
                            setError(result.message);
                        } else {
                            setError('Failed to submit the application.');
                        }
                    })
                    .catch(() => {});
            } catch (e) {
            }
            setViewBackdrop(false);

        },
    });

    const hideCopyOfApplicantCNICVerifyAlert = (x) => {
        setCopyOfApplicantCNICVerifyPopUp(x);
    };

    const hidePropertyDocVerifyAlert = (x) => {
        setPaidBillImagePopUp(x);
    };

    const callingUpdateDocumentStatusAPI = async () => {
        setViewBackdrop(true);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        let progId = null;
        let objStat = null;
        let remrks = "";
        let remarksDetail = "";

        if (flag_applicantCNICFront === -1 || flag_applicantCNICBack === -1 || flag_paidBillImageFlag === -1) {
            progId = 1;
            objStat = 1;
            remrks = "Documents Rejected.";
            remarksDetail = "Documents Objection in : ".concat(
                flag_applicantCNICFront === -1 ? "CNIC Front, " : "",
                flag_applicantCNICBack === -1 ? "CNIC Back, " : "",
                flag_paidBillImageFlag === -1 ? "Paid Bill Image" : ""
            );
        } else if (flag_applicantCNICFront === 1 && flag_applicantCNICBack === 1 && flag_paidBillImageFlag === 1) {
            progId = 2;
            objStat = 0;
            remrks = "Documents Verified.";
            remarksDetail = "CNIC Front Verified. CNIC Back Verified. Paid Bill Image Verified.";
        }


        const raw = JSON.stringify({
            applicationId: dialogRowData.applicationId,
            applicationProgressId: progId,
            objectionStatus: objStat,
            remarks: remrks,
            remarksDetail: remarksDetail,
            applicantCNICFrontFlag: flag_applicantCNICFront,
            applicantCNICBackFlag: flag_applicantCNICBack,
            paidBillImageFlag: flag_paidBillImageFlag,
            applicantCNICFrontRemarks: applicantCNICBackObjectionRemarks,
            applicantCNICBackRemarks: applicantCNICBackObjectionRemarks,
            paidBillImageRemarks: paidBillImageObjectionRemarks,
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        await fetch(cfpBaseUrl + "billAdjustment/lastPaidBillAdjustment/verifyDocuments", requestOptions)
            .then((response) => response.json())
            .then((result) => {
                if (result.status === "200") {
                    if (progId === 2) {
                        setResultPopup(null);
                        setVerifyRejectRemarks([]);
                        setApiPopup({
                            open: true,
                            type: 'success',
                            message: result.message || 'Documents verified.',
                        });
                    } else if (progId === 1) {
                        setApiPopup({ open: false, type: '', message: '' });
                        setVerifyRejectRemarks(buildAlbVerifyRejectRemarks());
                        setResultPopup('reject');
                    }
                } else {
                    setError(result.message || "Failed to update document status");
                }
                setViewBackdrop(false);
            })
            .catch((error) => {
                setError("Failed to update document status");
                setViewBackdrop(false);
            });
    };

    const updateDocumentStatus = () => {

        if (flag_applicantCNICFront !== null && flag_applicantCNICBack !== null && flag_paidBillImageFlag !== null) {
            callingUpdateDocumentStatusAPI();
        } else {
            setError("Check all the attached documents before submitting!");
        }
    };

    // const remarksFormik = useFormik({
    //     initialValues: {
    //         iv_remarks: "",
    //     },
    //     validationSchema: Yup.object({
    //         iv_remarks: Yup.string()
    //             .min(10, "Remarks should be at least 10 characters.")
    //             .max(100, "Remarks should be less than 100 characters.")
    //             .required("Enter remarks."),
    //     }),
    //     onSubmit: async (values) => {
    //         const x = -1
    //         const formattedDate = values.iv_approved_due_date.split("-").reverse().join("-");
    //         // setViewBackdrop(true)
    //         // try {
    //         //     const x = -1
    //         //     const formattedDate = values.split("-").reverse().join("-");
    //         //     console.log(formattedDate, values, 'formattedDate')
    //         //     var formdata = new FormData();
    //         //     formdata.append("applicationId", applicationId);
    //         //     formdata.append("lastModifiedBy", userId);
    //         //     formdata.append("applicationProgressId", x);
    //         //     formdata.append("approvedExtendedDueDate", formattedDate);
    //         //     const myHeaders = new Headers();
    //         //     myHeaders.append("Authorization", token);;
    //         //     var requestOptions = {
    //         //         method: 'POST',
    //         //         body: formdata,
    //         //         headers: myHeaders,
    //         //         redirect: 'follow',
    //         //     };
    //         //     await fetch(cfpBaseUrl + "dateExtention/dueDateAppProgId", requestOptions)
    //         //         .then(response => response.json())
    //         //         .then(result => {
    //         //             if (result.status === '200') {
    //         //                 setOpenCancelModal(false)
    //         //                 handleClose()
    //         //             } else if (result.message?.startsWith('Since the month end process')) {
    //         //                 setError(result.message);
    //         //             } else {
    //         //                 setError('Failed to submit the application.');
    //         //             }
    //         //         })
    //         //         .catch(() => {});
    //         // }
    //         // catch (e) {
    //         // }
    //         // setViewBackdrop(false)
    //     },
    // });

    let CONStatusBarArray = [
        {
            title1: "DOCUMENT",
            title2: "SUBMISSION",
        },
        {
            title1: "DOCUMENT",
            title2: "VERIFICATION",
        },
        {
            title1: "COMPLETED",
            title2: "",
        },
    ];


    const getBillAdjustmentDocuments = async (appId) => {
        setDocumentsLoading(true);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            "applicationId": appId
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        await fetch(cfpBaseUrl + "billAdjustment/lastPaidBillAdjustment/getDocuments", requestOptions)
            .then((response) => response.json())
            .then((result) => {
                if (result.status === "200" && result.data?.length > 0) {
                    const docData = result.data[0];
                    setDocuments(docData);
                    if (docData.applicantCNICFrontFlag != null) {
                        setFlag_applicantCNICFront(docData.applicantCNICFrontFlag);
                    }
                    if (docData.applicantCNICBackFlag != null) {
                        setFlag_applicantCNICBack(docData.applicantCNICBackFlag);
                    }
                    if (docData.paidBillImageFlag != null) {
                        setFlag_paidBillImageFlag(docData.paidBillImageFlag);
                    }
                } else {
                    setDocuments({});
                }
                setDocumentsLoading(false);
            })
            .catch((error) => {
                setDocuments({});
                setDocumentsLoading(false);
            });
    }



    const updateDocFlag = (documentName, value, remarks) => {
        switch (documentName) {
            case "copyOfApplicantCNIC":
                setFlag_applicantCNICFront(value);
                setFlag_applicantCNICBack(value);
                setApplicantCNICFrontObjectionRemarks(remarks);
                setApplicantCNICBackObjectionRemarks(remarks);
                setCopyOfApplicantCNICVerifyPopUp(false);
                break;
            case "paidBillImage":
                setFlag_paidBillImageFlag(value);
                setPaidBillImageObjectionRemarks(remarks);
                setPaidBillImagePopUp(false);
                break;

            default:
                break;
        }
    };

    return (
        <>
            <ServiceDashboardTables
                enabled={props.showTable && currentPath === "/adjust-last-bill-table"}
                isLoadingNormal={isLoad}
                isLoadingOverdue={isLoadd}
                normalTitle={`Adjust Last Bill ( ${numberFormatting(totalRecordsNormal) ? numberFormatting(totalRecordsNormal) : "-"} )`}
                overdueCount={numberFormatting(totalRecordsOverdue) ? numberFormatting(totalRecordsOverdue) : "-"}
                normalColumns={tblColumns}
                overdueColumns={tblColumnsOverDue}
                normalData={ddeApplicationsNormalToDataGrid}
                overdueData={ddeApplicationsOverdueToDataGrid}
                onRowClick={handleRowClick}
                mobileFields={["applicationId", "name", "applicationStatusId"]}
                showCompanyFilter={officeCode == 10}
                companies={DISCO_COMPANIES}
                selectedOfficeCode={selectedOfficeCode}
                onOfficeCodeChange={setSelectedOfficeCode}
                normalTableProps={{
                    firstPage: handleFirstPage,
                    lastPage: handleLastPage,
                    totalPages: totalPagesNormal,
                    totalRecords: totalRecordsNormal,
                    currentPage: currentPageNormal,
                    handleFilterDateFrom: handleDateFromFilter,
                    handleFilterDateTo: handleDateToFilter,
                    resetDateFilter: handleResetDateFilter,
                    handleFilterProgressId: handleProgressIdFilter,
                    handleFilterObjectionStatus: handleObjectionStatusFilter,
                    resetProgressIdFilter: handleResetProgressIdFilter,
                    resetObjectionStatusFilter: handleResetObjectionStatusFilter,
                    nextPage: handleNextPage,
                    previousPage: handlePreviousPage,
                }}
                overdueTableProps={{
                    firstPage: handleFirstPageOverdue,
                    nextPage: handleNextPageOverdue,
                    previousPage: handlePreviousPageOverdue,
                    lastPage: handleLastPageOverdue,
                    handleFilterDateFrom: handleDateFromFilterOverdue,
                    handleFilterDateTo: handleDateToFilterOverdue,
                    resetDateFilter: handleResetDateFilterOverdue,
                    resetProgressIdFilter: handleResetProgressIdFilterOverdue,
                    resetObjectionStatusFilter: handleResetObjectionStatusFilterOverdue,
                    handleFilterProgressId: handleProgressIdFilterOverdue,
                    handleFilterObjectionStatus: handleObjectionStatusFilterOverdue,
                    totalPages: totalPagesOverdue,
                    totalRecords: totalRecordsOverdue,
                    currentPage: currentPageOverdue,
                }}
            />

            {/* Main Popup */}
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth={true}
                maxWidth="xl"
                {...workflowDialogShellProps(isWorkflowMobile)}
                className={workflowDialogClassName(
                    `main-dialog alb-workflow-dialog${
                    dialogRowData.applicationProgressId === 1
                    && dialogRowData.objectionStatus === 1
                        ? ' alb-workflow-dialog--objection'
                        : ''
                }`,
                    isWorkflowMobile,
                )}
                PaperProps={{ className: 'alb-workflow-dialog-paper' }}
            >
                <DialogTitle className="dialog-title">
                    <div className="alb-dialog-header">
                        <Typography className="applicationTitleText">
                            Adjust Last Bill -
                            <span style={{ color: 'white' }}>
                                {(dialogRowData.applicationProgressId == 1)
                                    ? ' Document Verification'
                                    : (dialogRowData.applicationProgressId == 2)
                                        ? ' Completed'
                                        : ' Application Submission'}
                            </span>
                        </Typography>
                        <button type="button" className="closeIcon" onClick={handleClose} aria-label="Close dialog">
                            <CloseIcon id="clearPopup" sx={{ color: 'white' }} />
                        </button>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText className="dialog-content">
                        <Grid
                            container
                            spacing={1}
                            className={`headercontainer${
                                dialogRowData.applicationProgressId === 1
                                && dialogRowData.objectionStatus === 1
                                    ? ' headercontainer--compact'
                                    : ''
                            }`}
                        >
                            <Grid item lg={12} className="status-bar">
                                <StepProgressBar
                                    array={CONStatusBarArray}
                                    applicationProgressId={getAdjustLastBillStepBarProgressId(dialogRowData)}
                                    objection={
                                        toProgressId(dialogRowData.applicationProgressId) === 1 &&
                                        toProgressId(dialogRowData.objectionStatus) === 1
                                            ? 0
                                            : toProgressId(dialogRowData.objectionStatus)
                                    }
                                    submittedStepComplete={getAdjustLastBillSubmittedStepComplete(dialogRowData)}
                                    openDetailsPopUp={openDetailsPopUp}
                                    pageName="Adjust Last Bill"
                                />
                            </Grid>
                            <Grid item xs={12} className="application-details">
                                <div className="alb-application-details-body">
                                <p className="alb-section-label">Application Details</p>
                                <div className="alb-details-grid">
                                    <div className="first-row-item alb-details-grid__app-id">
                                        <p className="prop-title">Application Id.</p>
                                        <p className="prop-detail">{dialogRowData.applicationId}</p>
                                    </div>
                                    <div className="first-row-item alb-details-grid__ref-no">
                                        <p className="prop-title">Reference No.</p>
                                        <p className="prop-detail">{dialogRowData.referenceNo || '-'}</p>
                                    </div>
                                    <div className="first-row-item alb-details-grid__cnic">
                                        <p className="prop-title">CNIC</p>
                                        <p className="prop-detail">{dialogRowData.applicantCNIC || '-'}</p>
                                    </div>
                                    <div className="first-row-item alb-details-grid__address">
                                        <p className="prop-title">Address</p>
                                        <p className="prop-detail">{dialogRowData.applicantAddress || '-'}</p>
                                    </div>
                                    <div className="first-row-item alb-details-grid__subdivision">
                                        <p className="prop-title">Subdivision</p>
                                        <p className="prop-detail">
                                            {subdivisionName(dialogRowData.subDivisionCode, subDivisions)}
                                        </p>
                                    </div>
                                    <div className="first-row-item alb-details-grid__name">
                                        <p className="prop-title">Name</p>
                                        <p className="prop-detail">{dialogRowData.applicantName || '-'}</p>
                                    </div>
                                    <div className="first-row-item alb-details-grid__cur-amt">
                                        <p className="prop-title">Current Bill Amount</p>
                                        <p className="prop-detail">
                                            {dialogRowData.currentBillAmount
                                                ? Number(dialogRowData.currentBillAmount).toLocaleString()
                                                : '-'}
                                        </p>
                                    </div>
                                    <div className="first-row-item alb-details-grid__prev-amt">
                                        <p className="prop-title">Previous Bill Amount</p>
                                        <p className="prop-detail">
                                            {dialogRowData.previousBillAmount
                                                ? Number(dialogRowData.previousBillAmount).toLocaleString()
                                                : '-'}
                                        </p>
                                    </div>
                                    <div className="first-row-item alb-details-grid__cur-month">
                                        <p className="prop-title">Current Bill Month</p>
                                        <p className="prop-detail">
                                            {convertDate(dialogRowData.currentBillMonth) || '-'}
                                        </p>
                                    </div>
                                    <div className="first-row-item alb-details-grid__prev-month">
                                        <p className="prop-title">Previous Bill Month</p>
                                        <p className="prop-detail">
                                            {convertDate(dialogRowData.previousBillMonth) || '-'}
                                        </p>
                                    </div>
                                    <div className="first-row-item alb-details-grid__claimed">
                                        <p className="prop-title">Claimed Payment</p>
                                        <p className="prop-detail">{dialogRowData.claimedPaymentAmount || '-'}</p>
                                    </div>
                                    <div className="first-row-item alb-details-grid__pay-date">
                                        <p className="prop-title">Payment Date</p>
                                        <p className="prop-detail">
                                            {convertDate(dialogRowData.paymentDate) || '-'}
                                        </p>
                                    </div>
                                </div>
                                </div>
                            </Grid>
                            <Grid item className='processing-summary'>
                                <p className='title'>Activity Log</p>
                                <ProcessingSummaryTableBilling data={tableDataProcessingSummary} columns={tableColumnsProcessingSummary} openDetailsPopUp={openDetailsPopUp} />
                            </Grid>
                            <Grid
                                item
                                className={`action-form${
                                    dialogRowData.applicationProgressId === 1
                                    && dialogRowData.objectionStatus === 1
                                        ? ' action-form--compact'
                                        : ''
                                }`}
                            >
                                <div
                                    className={`fields${
                                        dialogRowData.applicationProgressId === 1
                                        && dialogRowData.objectionStatus === 1
                                            ? ' fields--objection'
                                            : ''
                                    }`}
                                >
                                    {dialogRowData.applicationProgressId === 0 ? (
                                        <>
                                            <h3 className="step-title">Documents Pending</h3>
                                            <div className="description-box">

                                            </div>
                                        </>
                                    ) : dialogRowData.applicationProgressId === 1 &&
                                        (dialogRowData.objectionStatus === 0 ||
                                            dialogRowData.objectionStatus === 2) ? (
                                        <>
                                            {CheckPermissions(permissions, 'General Services', 'Adjust Last Bill', 'Workflow Permissions', 'Document Verification') ? (
                                                <>
                                                    <h3 className="step-title">Document Verification</h3>
                                                    <Grid
                                                        className="document-verification-container"
                                                        container
                                                        spacing={1}
                                                        sx={{
                                                            display: "flex",
                                                            justifyContent: "flex-start",
                                                            marginTop: "1%",
                                                            padding: "2%",
                                                        }}
                                                    >
                                                        {(documnets?.applicantCNICFront ||
                                                            documnets.applicantCNICBack) && (
                                                                <Grid item lg={2} className="alb-doc-card-wrap">
                                                                    <div
                                                                        className="alb-doc-card docContainer"
                                                                        style={{
                                                                            backgroundColor: getDocumentBackGroundColor(
                                                                                documnets?.applicantCNICFrontFlag
                                                                                    ?? flag_applicantCNICFront
                                                                                    ?? dialogRowData.applicantCNICFrontFlag,
                                                                            ),
                                                                        }}
                                                                    >
                                                                        <div className="alb-doc-card__body">
                                                                            <div
                                                                                onClick={() => {
                                                                                    if (!copyOfApplicantCNICVerifyPopUp) {
                                                                                        setCopyOfApplicantCNICVerifyPopUp(true);
                                                                                    }
                                                                                }}
                                                                                style={{
                                                                                    display: "flex",
                                                                                    justifyContent: "space-between",
                                                                                    flexDirection: "column",
                                                                                    alignItems: "center",
                                                                                }}
                                                                            >
                                                                                {documnets.applicantCNICFront.slice(
                                                                                    0,
                                                                                    6
                                                                                ) === "data:i" ? (
                                                                                    flag_applicantCNICFront === 1 ? (
                                                                                        <div className="alb-doc-thumb-wrap">
                                                                                            <Base64Image
                                                                                                data={
                                                                                                    documnets.applicantCNICFront
                                                                                                }
                                                                                                width="80"
                                                                                                height="50"
                                                                                            />
                                                                                            <Base64Image
                                                                                                data={
                                                                                                    documnets.applicantCNICBack
                                                                                                }
                                                                                                width="80"
                                                                                                height="50"
                                                                                            />
                                                                                            <img
                                                                                                src={tickicon}
                                                                                                width="25px"
                                                                                                height="25px"
                                                                                                alt="Tick Icon"
                                                                                                className="alb-doc-status-icon"
                                                                                            />
                                                                                        </div>
                                                                                    ) : flag_applicantCNICFront === -1 ? (
                                                                                        <div className="alb-doc-thumb-wrap">
                                                                                            <Base64Image
                                                                                                data={
                                                                                                    documnets.applicantCNICFront
                                                                                                }
                                                                                                width="80"
                                                                                                height="50"
                                                                                            />
                                                                                            <Base64Image
                                                                                                data={
                                                                                                    documnets.applicantCNICBack
                                                                                                }
                                                                                                width="80"
                                                                                                height="50"
                                                                                            />
                                                                                            <img
                                                                                                src={crossIcon}
                                                                                                width="25px"
                                                                                                height="25px"
                                                                                                alt="Cross Icon"
                                                                                                className="alb-doc-status-icon"
                                                                                            />
                                                                                        </div>
                                                                                    ) : (
                                                                                        <>
                                                                                            <Base64Image
                                                                                                data={
                                                                                                    documnets.applicantCNICFront
                                                                                                }
                                                                                                width="80"
                                                                                                height="50"
                                                                                            />
                                                                                            <Base64Image
                                                                                                data={
                                                                                                    documnets.applicantCNICBack
                                                                                                }
                                                                                                width="80"
                                                                                                height="50"
                                                                                            />
                                                                                        </>
                                                                                    )
                                                                                ) : (
                                                                                    <Base64Image data={pdfIcon} width="40" />
                                                                                )}
                                                                                {copyOfApplicantCNICVerifyPopUp && (
                                                                                    <OpenBase64ImageInPopup
                                                                                        docVerifyPopUp={
                                                                                            copyOfApplicantCNICVerifyPopUp
                                                                                        }
                                                                                        hideDocVerifyPopup={
                                                                                            hideCopyOfApplicantCNICVerifyAlert
                                                                                        }
                                                                                        documentName="Applicant CNIC"
                                                                                        documentImage={
                                                                                            documnets.applicantCNICFront
                                                                                        }
                                                                                        backDocumentImage={
                                                                                            documnets.applicantCNICBack
                                                                                        }
                                                                                        width={"100%"}
                                                                                        document={
                                                                                            documnets.applicantCNICFront
                                                                                        }
                                                                                        documentFlag={
                                                                                            documnets.applicantCNICFrontFlag
                                                                                        }
                                                                                        applicationProgressId={
                                                                                            dialogRowData.applicationProgressId
                                                                                        }
                                                                                        objectionStatus={
                                                                                            dialogRowData.objectionStatus
                                                                                        }
                                                                                        updateDocFlag={updateDocFlag}
                                                                                        documentRemarks={
                                                                                            applicantCNICBackObjectionRemarks
                                                                                        }
                                                                                        titleToUpdateFlag="copyOfApplicantCNIC"
                                                                                        flag_document={flag_applicantCNICFront}
                                                                                        flag_documentBack={
                                                                                            flag_applicantCNICBack
                                                                                        }
                                                                                    />
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        <div className="tittlegrid">
                                                                            <p className="docTitle">Applicant's CNIC.</p>
                                                                        </div>
                                                                    </div>
                                                                </Grid>
                                                            )}

                                                        {documnets?.paidBillImage && (
                                                            <Grid item lg={2} className="alb-doc-card-wrap">
                                                                <div
                                                                    className="alb-doc-card docContainer"
                                                                    style={{
                                                                        backgroundColor: getDocumentBackGroundColor(
                                                                            documnets?.paidBillImageFlag
                                                                                ?? flag_paidBillImageFlag,
                                                                        ),
                                                                    }}
                                                                >
                                                                    <div className="alb-doc-card__body">
                                                                        <div
                                                                            onClick={() => {
                                                                                if (!paidBillImagePopUp) {
                                                                                    setPaidBillImagePopUp(true);
                                                                                }
                                                                            }}
                                                                            style={{
                                                                                display: "flex",
                                                                                justifyContent: "space-between",
                                                                                flexDirection: "column",
                                                                                alignItems: "center",
                                                                            }}
                                                                        >
                                                                            {documnets.paidBillImage?.slice(0, 6) === "data:i" ? (
                                                                                (flag_paidBillImageFlag === 1 || documnets.paidBillImageFlag === 1) ? (
                                                                                    <div className="alb-doc-thumb-wrap">
                                                                                        <Base64Image
                                                                                            data={
                                                                                                documnets.paidBillImage
                                                                                            }
                                                                                            width="80"
                                                                                            height="100"
                                                                                        />
                                                                                        <img
                                                                                            src={tickicon}
                                                                                            width="25px"
                                                                                            height="25px"
                                                                                            alt="Tick Icon"
                                                                                            className="alb-doc-status-icon"
                                                                                        />
                                                                                    </div>
                                                                                ) : (flag_paidBillImageFlag === -1 || documnets.paidBillImageFlag === -1) ? (
                                                                                    <div className="alb-doc-thumb-wrap">
                                                                                        <Base64Image
                                                                                            data={documnets.paidBillImage}
                                                                                            width="80"
                                                                                            height="50"
                                                                                        />
                                                                                        <img
                                                                                            src={crossIcon}
                                                                                            width="25px"
                                                                                            height="25px"
                                                                                            alt="Cross Icon"
                                                                                            className="alb-doc-status-icon"
                                                                                        />
                                                                                    </div>
                                                                                ) : (
                                                                                    <Base64Image
                                                                                        data={documnets.paidBillImage}
                                                                                        width="80"
                                                                                        height="50"
                                                                                    />
                                                                                )
                                                                            ) : (
                                                                                <Base64Image data={pdfIcon} width="40" />
                                                                            )}
                                                                            {paidBillImagePopUp && (
                                                                                <OpenBase64ImageInPopup
                                                                                    docVerifyPopUp={paidBillImagePopUp}
                                                                                    hideDocVerifyPopup={hidePropertyDocVerifyAlert}
                                                                                    documentName="Paid Bill Image"
                                                                                    documentImage={documnets.paidBillImage}
                                                                                    width={"100%"}
                                                                                    document={documnets.paidBillImage}
                                                                                    documentFlag={documnets.paidBillImageFlag}
                                                                                    applicationProgressId={dialogRowData.applicationProgressId}
                                                                                    objectionStatus={dialogRowData.objectionStatus}
                                                                                    updateDocFlag={updateDocFlag}
                                                                                    documentRemarks={paidBillImageObjectionRemarks}
                                                                                    titleToUpdateFlag="paidBillImage"
                                                                                    flag_document={flag_paidBillImageFlag}
                                                                                />
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <div className="tittlegrid">
                                                                        <p className="docTitle">Paid Bill Image</p>
                                                                    </div>
                                                                </div>
                                                            </Grid>
                                                        )}

                                                    </Grid>
                                                </>
                                            ) : (
                                                <>
                                                    <h3 className="step-title">Documents Verification</h3>
                                                    <div className="description-box description-box--error">
                                                        <p className="group-description">
                                                            <InfoIcon className="icon" /> Document verification is in process by the Customer Service Lead.
                                                        </p>
                                                    </div>
                                                </>
                                            )}
                                        </>
                                    ) : dialogRowData.applicationProgressId === 1 &&
                                        dialogRowData.objectionStatus === 1 ? (
                                        <>
                                            <h3 className="step-title">Documents Objection</h3>
                                            <Grid
                                                className="document-verification-container document-verification-container--objection"
                                                container
                                                spacing={1}
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "flex-start",
                                                }}
                                            >
                                                {(documnets?.applicantCNICFront ||
                                                    documnets?.applicantCNICBack) && (
                                                        <Grid item lg={2} className="alb-doc-card-wrap">
                                                            <div
                                                                className="alb-doc-card docContainer"
                                                                style={{
                                                                    backgroundColor: getDocumentBackGroundColor(
                                                                        documnets?.applicantCNICFrontFlag
                                                                            ?? flag_applicantCNICFront,
                                                                    ),
                                                                }}
                                                            >
                                                                <div className="alb-doc-card__body">
                                                                    <div
                                                                        onClick={() => {
                                                                            if (!copyOfApplicantCNICVerifyPopUp) {
                                                                                setCopyOfApplicantCNICVerifyPopUp(true);
                                                                            }
                                                                        }}
                                                                        style={{
                                                                            display: "flex",
                                                                            justifyContent: "space-between",
                                                                            flexDirection: "column",
                                                                            alignItems: "center",
                                                                        }}
                                                                    >
                                                                        {documnets?.applicantCNICFront?.slice(0, 6) === "data:i" ? (
                                                                            flag_applicantCNICFront === 1 ? (
                                                                                <div className="alb-doc-thumb-wrap">
                                                                                    <Base64Image
                                                                                        data={documnets.applicantCNICFront}
                                                                                        width="80"
                                                                                        height="50"
                                                                                    />
                                                                                    <Base64Image
                                                                                        data={documnets.applicantCNICBack}
                                                                                        width="80"
                                                                                        height="50"
                                                                                    />
                                                                                    <img
                                                                                        src={tickicon}
                                                                                        width="25px"
                                                                                        height="25px"
                                                                                        alt="Tick Icon"
                                                                                        className="alb-doc-status-icon"
                                                                                    />
                                                                                </div>
                                                                            ) : (documnets?.applicantCNICFrontFlag === -1 || flag_applicantCNICFront === -1) ? (
                                                                                <div className="alb-doc-thumb-wrap">
                                                                                    <Base64Image
                                                                                        data={documnets.applicantCNICFront}
                                                                                        width="80"
                                                                                        height="50"
                                                                                    />
                                                                                    <Base64Image
                                                                                        data={documnets.applicantCNICBack}
                                                                                        width="80"
                                                                                        height="50"
                                                                                    />
                                                                                    <img
                                                                                        src={crossIcon}
                                                                                        width="25px"
                                                                                        height="25px"
                                                                                        alt="Cross Icon"
                                                                                        className="alb-doc-status-icon"
                                                                                    />
                                                                                </div>
                                                                            ) : (
                                                                                <>
                                                                                    <Base64Image
                                                                                        data={documnets.applicantCNICFront}
                                                                                        width="80"
                                                                                        height="50"
                                                                                    />
                                                                                    <Base64Image
                                                                                        data={documnets.applicantCNICBack}
                                                                                        width="80"
                                                                                        height="50"
                                                                                    />
                                                                                </>
                                                                            )
                                                                        ) : (
                                                                            <Base64Image data={pdfIcon} width="40" />
                                                                        )}
                                                                        {copyOfApplicantCNICVerifyPopUp && (
                                                                            <OpenBase64ImageInPopup
                                                                                docVerifyPopUp={copyOfApplicantCNICVerifyPopUp}
                                                                                hideDocVerifyPopup={hideCopyOfApplicantCNICVerifyAlert}
                                                                                documentName="Applicant CNIC"
                                                                                documentImage={documnets.applicantCNICFront}
                                                                                backDocumentImage={documnets.applicantCNICBack}
                                                                                width={"100%"}
                                                                                document={documnets.applicantCNICFront}
                                                                                documentFlag={documnets.applicantCNICFrontFlag}
                                                                                applicationProgressId={dialogRowData.applicationProgressId}
                                                                                objectionStatus={dialogRowData.objectionStatus}
                                                                                updateDocFlag={updateDocFlag}
                                                                                documentRemarks={applicantCNICBackObjectionRemarks}
                                                                                titleToUpdateFlag="copyOfApplicantCNIC"
                                                                                flag_document={flag_applicantCNICFront}
                                                                                flag_documentBack={flag_applicantCNICBack}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div className="tittlegrid">
                                                                    <p className="docTitle">Applicant's CNIC.</p>
                                                                </div>
                                                            </div>
                                                        </Grid>
                                                    )}

                                                {documnets?.paidBillImage && (
                                                    <Grid item lg={2} className="alb-doc-card-wrap">
                                                        <div
                                                            className="alb-doc-card docContainer"
                                                            style={{
                                                                backgroundColor: getDocumentBackGroundColor(
                                                                    documnets?.paidBillImageFlag
                                                                        ?? flag_paidBillImageFlag,
                                                                ),
                                                            }}
                                                        >
                                                            <div className="alb-doc-card__body">
                                                                <div
                                                                    onClick={() => {
                                                                        if (!paidBillImagePopUp) {
                                                                            setPaidBillImagePopUp(true);
                                                                        }
                                                                    }}
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        flexDirection: "column",
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    {documnets.paidBillImage?.slice(0, 6) === "data:i" ? (
                                                                        flag_paidBillImageFlag === 1 ? (
                                                                            <div className="alb-doc-thumb-wrap">
                                                                                <Base64Image
                                                                                    data={documnets.paidBillImage}
                                                                                    width="80"
                                                                                    height="50"
                                                                                />
                                                                                <img
                                                                                    src={tickicon}
                                                                                    width="25px"
                                                                                    height="25px"
                                                                                    alt="Tick Icon"
                                                                                    className="alb-doc-status-icon"
                                                                                />
                                                                            </div>
                                                                        ) : (documnets.paidBillImageFlag === -1 || flag_paidBillImageFlag === -1) ? (
                                                                            <div className="alb-doc-thumb-wrap">
                                                                                <Base64Image
                                                                                    data={documnets.paidBillImage}
                                                                                    width="80"
                                                                                    height="50"
                                                                                />
                                                                                <img
                                                                                    src={crossIcon}
                                                                                    width="25px"
                                                                                    height="25px"
                                                                                    alt="Cross Icon"
                                                                                    className="alb-doc-status-icon"
                                                                                />
                                                                            </div>
                                                                        ) : (
                                                                            <Base64Image
                                                                                data={documnets.paidBillImage}
                                                                                width="80"
                                                                                height="50"
                                                                            />
                                                                        )
                                                                    ) : (
                                                                        <Base64Image data={pdfIcon} width="40" />
                                                                    )}
                                                                    {paidBillImagePopUp && (
                                                                        <OpenBase64ImageInPopup
                                                                            docVerifyPopUp={paidBillImagePopUp}
                                                                            hideDocVerifyPopup={hidePropertyDocVerifyAlert}
                                                                            documentName="Paid Bill Image"
                                                                            documentImage={documnets.paidBillImage}
                                                                            width={"100%"}
                                                                            document={documnets.paidBillImage}
                                                                            documentFlag={documnets.paidBillImageFlag}
                                                                            applicationProgressId={dialogRowData.applicationProgressId}
                                                                            objectionStatus={dialogRowData.objectionStatus}
                                                                            updateDocFlag={updateDocFlag}
                                                                            documentRemarks={paidBillImageObjectionRemarks}
                                                                            titleToUpdateFlag="paidBillImage"
                                                                            flag_document={flag_paidBillImageFlag}
                                                                        />
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="tittlegrid">
                                                                <p className="docTitle">Paid Bill Image</p>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                )}
                                            </Grid>
                                        </>
                                    ) : dialogRowData.applicationProgressId === 2 &&
                                        (dialogRowData.objectionStatus === 0 ||
                                            dialogRowData.objectionStatus === 2) ? (
                                        <>
                                            <div className="step-title step-title--with-action">
                                                <h4>Application Completed</h4>
                                                <Button
                                                    variant="outlined"
                                                    onClick={() => downloadBill(dialogRowData.referenceNo)}
                                                    className="alb-bill-btn"
                                                >
                                                    <DescriptionIcon sx={{ color: '#006ad1' }} /> Bill
                                                </Button>
                                            </div>
                                            <div className="alb-status-banner alb-status-banner--success">
                                                <CheckCircleIcon />
                                                Payment Adjusted Successfully
                                            </div>
                                        </>

                                    ) : null}
                                </div>
                                <div
                                    className={`actions${
                                        dialogRowData.applicationProgressId === 1
                                        && dialogRowData.objectionStatus === 1
                                            ? ' actions--compact'
                                            : ''
                                    }`}
                                >
                                    {dialogRowData.applicationProgressId === 1 &&
                                        (dialogRowData.objectionStatus === 0 ||
                                            dialogRowData.objectionStatus === 2) ? (
                                        CheckPermissions(permissions, 'General Services', 'Adjust Last Bill', 'Workflow Permissions', 'Document Verification') ?
                                            <>
                                                {(dialogRowData.applicantCNICFrontFlag !== 1 ||
                                                    dialogRowData.applicantCNICBackFlag !== 1 ||
                                                    (documnets?.paidBillImage && documnets?.paidBillImageFlag !== 1)) ? (
                                                    <>
                                                        <button
                                                            disabled={
                                                                !flag_applicantCNICFront ||
                                                                !flag_applicantCNICBack ||
                                                                (documnets?.paidBillImage && !flag_paidBillImageFlag)
                                                            }
                                                            onClick={() => updateDocumentStatus()}
                                                            className={
                                                                (flag_applicantCNICFront === -1 ||
                                                                    flag_applicantCNICBack === -1 ||
                                                                    flag_paidBillImageFlag === -1)
                                                                    ? 'view-button view-button--reject'
                                                                    : 'view-button'
                                                            }
                                                        >
                                                            {flag_applicantCNICFront === -1 ||
                                                                flag_applicantCNICBack === -1 || flag_paidBillImageFlag === -1
                                                                ? "Reject"
                                                                : "Verify"}
                                                        </button>
                                                    </>
                                                ) : null}
                                            </>
                                            :
                                            null
                                    ) : dialogRowData.applicationProgressId === 1 &&
                                        dialogRowData.objectionStatus === 1 ? (
                                        <>

                                            <button
                                                type="button"
                                                onClick={() => {
                                                    setOpen(false);
                                                    if (!props.showTable && typeof props.onCloseSearchResults === 'function') {
                                                        props.onCloseSearchResults();
                                                    }
                                                    navigate("/adjust-last-bill-update", { state: { dialogRowData } });
                                                }}
                                                className="view-button view-button--reupload"
                                            >
                                                Re-Upload Document
                                            </button>

                                        </>
                                    ) : null}
                                </div>
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
            </Dialog>

            <Dialog
                open={applicationSubittedPopUp}
                onClose={() => setApplicationSubmittedPopUp(false)}
                fullWidth
                maxWidth="md"
                className="wf-submitted-dialog"
                PaperProps={{ className: 'wf-submitted-dialog__paper' }}
            >
                <DialogTitle className="dialog-title">
                    <div className="wf-dialog-header">
                        <Typography className="wf-dialog-title-text">Application Submitted</Typography>
                        <button
                            type="button"
                            className="wf-dialog-close"
                            onClick={() => setApplicationSubmittedPopUp(false)}
                            aria-label="Close dialog"
                        >
                            <CloseIcon id="clearPopup" />
                        </button>
                    </div>
                </DialogTitle>
                <DialogContent className="wf-submitted-dialog__content">
                    <div className="wf-application-details-body">
                        <p className="wf-section-label">Application Details</p>
                        <div className="wf-details-grid">
                            <div className="wf-detail-item wf-detail-item--span2">
                                <p className="prop-title">Application Id</p>
                                <p className="prop-detail">{dialogRowData.applicationId || '-'}</p>
                            </div>
                            <div className="wf-detail-item wf-detail-item--span2">
                                <p className="prop-title">Applicant Name</p>
                                <p className="prop-detail">{dialogRowData.applicantName || '-'}</p>
                            </div>
                            <div className="wf-detail-item wf-detail-item--span2">
                                <p className="prop-title">Received From</p>
                                <p className="prop-detail">{dialogRowData.cfcName || '-'}</p>
                            </div>
                            <div className="wf-detail-item">
                                <p className="prop-title">Applied Date</p>
                                <p className="prop-detail">{convertDate(dialogRowData.creationDate) || '-'}</p>
                            </div>
                            <div className="wf-detail-item">
                                <p className="prop-title">Subdivision</p>
                                <p className="prop-detail">
                                    {subdivisionName(dialogRowData.subDivisionCode, subDivisions) || '-'}
                                </p>
                            </div>
                            <div className="wf-detail-item">
                                <p className="prop-title">Current Bill Amount</p>
                                <p className="prop-detail">
                                    {dialogRowData.currentBillAmount != null && dialogRowData.currentBillAmount !== ''
                                        ? Number(dialogRowData.currentBillAmount).toLocaleString()
                                        : '-'}
                                </p>
                            </div>
                            <div className="wf-detail-item">
                                <p className="prop-title">Previous Bill Amount</p>
                                <p className="prop-detail">
                                    {dialogRowData.previousBillAmount != null && dialogRowData.previousBillAmount !== ''
                                        ? Number(dialogRowData.previousBillAmount).toLocaleString()
                                        : '-'}
                                </p>
                            </div>
                            <div className="wf-detail-item wf-detail-item--span2">
                                <p className="prop-title">Sub. Through</p>
                                <p className="prop-detail">{dialogRowData.submittedThrough || '-'}</p>
                            </div>
                        </div>
                    </div>
                    {(documnets?.applicantCNICFront || documnets?.applicantCNICBack || documnets?.paidBillImage) ? (
                        <div className="wf-submitted-docs">
                            <p className="wf-section-label">Attached Documents</p>
                            <div className="wf-submitted-docs__grid">
                                {documnets?.applicantCNICFront ? (
                                    <button
                                        type="button"
                                        className="wf-submitted-doc-card"
                                        onClick={() => setSubmittedDocViewer({
                                            open: true,
                                            image: normalizeDocumentDataUrl(documnets.applicantCNICFront),
                                            name: 'CNIC Front',
                                        })}
                                    >
                                        <p className="wf-submitted-doc-card__label">CNIC Front</p>
                                        {renderSubmittedDocumentPreview(documnets.applicantCNICFront, 'CNIC Front')}
                                    </button>
                                ) : null}
                                {documnets?.applicantCNICBack ? (
                                    <button
                                        type="button"
                                        className="wf-submitted-doc-card"
                                        onClick={() => setSubmittedDocViewer({
                                            open: true,
                                            image: normalizeDocumentDataUrl(documnets.applicantCNICBack),
                                            name: 'CNIC Back',
                                        })}
                                    >
                                        <p className="wf-submitted-doc-card__label">CNIC Back</p>
                                        {renderSubmittedDocumentPreview(documnets.applicantCNICBack, 'CNIC Back')}
                                    </button>
                                ) : null}
                                {documnets?.paidBillImage ? (
                                    <button
                                        type="button"
                                        className="wf-submitted-doc-card"
                                        onClick={() => setSubmittedDocViewer({
                                            open: true,
                                            image: normalizeDocumentDataUrl(documnets.paidBillImage),
                                            name: 'Paid Bill Image',
                                        })}
                                    >
                                        <p className="wf-submitted-doc-card__label">Paid Bill Image</p>
                                        {renderSubmittedDocumentPreview(documnets.paidBillImage, 'Paid Bill Image')}
                                    </button>
                                ) : null}
                            </div>
                        </div>
                    ) : null}
                </DialogContent>
                <DialogActions className="wf-submitted-dialog__footer">
                    <p className="wf-submitted-dialog__footer-text">
                        Application Submitted by:{' '}
                        {String(dialogRowData.createdBy).length === 13 && /^\d+$/.test(dialogRowData.createdBy)
                            ? dialogRowData.applicantName
                            : dialogRowData.createdBy}{' '}
                        on: {convertDatewithTime(dialogRowData.creationDate)}
                    </p>
                </DialogActions>
                {submittedDocViewer.open ? (
                    <OpenBase64ImageInPopup
                        docVerifyPopUp={submittedDocViewer.open}
                        hideDocVerifyPopup={() => setSubmittedDocViewer({ open: false, image: '', name: '' })}
                        documentName={submittedDocViewer.name}
                        documentImage={submittedDocViewer.image}
                        width="100%"
                        document={submittedDocViewer.image}
                        applicationProgressId={3}
                        objectionStatus={0}
                    />
                ) : null}
            </Dialog>

            <Dialog
                open={actionTakenPopup}
                onClose={() => setActionTakenPopup(false)}
                fullWidth
                maxWidth="md"
                className="wf-action-taken-dialog"
                PaperProps={{ className: 'wf-action-taken-dialog__paper' }}
            >
                <DialogTitle className="dialog-title">
                    <div className="wf-dialog-header">
                        <Typography className="wf-dialog-title-text">Application Approved</Typography>
                        <button
                            type="button"
                            className="wf-dialog-close"
                            onClick={() => setActionTakenPopup(false)}
                            aria-label="Close dialog"
                        >
                            <CloseIcon id="clearPopup" />
                        </button>
                    </div>
                </DialogTitle>
                <DialogContent className="wf-action-taken-dialog__content">
                    <div className="wf-action-taken-panel">
                        <p className="wf-action-taken-panel__title">Action Summary</p>
                        <p className="wf-action-taken-panel__remarks">{dialogRowData.remarks || 'Documents Verified.'}</p>
                        {dialogRowData.remarksDetail ? (
                            <p className="wf-action-taken-panel__remarks-detail">{dialogRowData.remarksDetail}</p>
                        ) : null}
                        <Box className="dde-result-dialog__actions" sx={{ mt: 2 }}>
                            <Button
                                type="button"
                                variant="outlined"
                                className="dde-result-dialog__bill-btn"
                                onClick={() => downloadBill(dialogRowData.referenceNo || dialogRowData.refNo)}
                            >
                                <DescriptionIcon className="dde-result-dialog__bill-icon" />
                                Download Bill
                            </Button>
                        </Box>
                    </div>
                </DialogContent>
                <DialogActions className="wf-action-taken-dialog__footer">
                    <p className="wf-action-taken-dialog__footer-text">
                        Application Approved by:{' '}
                        {String(dialogRowData.lastModifiedBy || dialogRowData.createdBy).length === 13
                            && /^\d+$/.test(String(dialogRowData.lastModifiedBy || dialogRowData.createdBy))
                            ? dialogRowData.applicantName
                            : (dialogRowData.lastModifiedBy || dialogRowData.createdBy)}{' '}
                        on: {convertDatewithTime(dialogRowData.lastModificationDate || dialogRowData.creationDate)}
                    </p>
                </DialogActions>
            </Dialog>


            {/* Remarks Dialog */}
            <Dialog open={openCancelModal} className='objectionDialog' onClose={handleCloseRemarks} maxWidth="sm" fullWidth>
                <DialogTitle className="objection-dialog-title">
                    <Grid container className='objectionheadercontainer'>
                        <Grid item lg={11} className='applicationTitleGrid'>
                            <Typography className="applicationTitleText">Remarks</Typography>
                        </Grid>
                        <Grid item lg={1} className="closeIcon">
                            <CloseIcon id="clearPopup" onClick={handleCloseRemarks} />
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        placeholder="Enter Remarks"
                        type="text"
                        fullWidth
                        variant="outlined"
                        onChange={remarksFormik.handleChange}
                        onBlur={remarksFormik.handleBlur}
                        name="iv_remarks"
                        value={remarksFormik.values.iv_remarks}
                        multiline
                        rows={4}
                        InputLabelProps={{ shrink: false }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '&.Mui-focused fieldset': {
                                    borderColor: 'rgba(173, 170, 170, 0.6)',
                                },
                                '&:hover fieldset': {
                                    borderColor: 'rgba(173, 170, 170, 0.6)',
                                },
                            },
                        }}
                    />
                    {remarksFormik.touched.iv_remarks && remarksFormik.errors.iv_remarks && (
                        <p style={{ color: "#f73232", fontSize: "1rem" }}>
                            {remarksFormik.errors.iv_remarks}
                        </p>
                    )}
                    <Grid item lg={12} >
                        {
                            error &&
                            <Error
                                error={error}
                                onClose={() => errorCloses()}
                                backgroundColor="#FFC0CB"
                                textColor="#bb0303"
                                iconColor="#bb0303"
                            />
                        }
                    </Grid>
                    <DialogActions className="objection-dialog-action">
                        <Button onClick={remarksFormik.handleSubmit} type="submit" className='submit-button'>Confirm</Button>
                        <Button onClick={handleCloseRemarks} className='reject-button'>Cancel</Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>

            <Dialog
                open={Boolean(activeAlbResultDialog)}
                onClose={handleCloseResultPopup}
                className={`dde-result-dialog${resultPopup === 'reject' || apiPopup.type === 'error' ? ' dde-result-dialog--reject' : ''}`}
                fullWidth
                maxWidth="sm"
                PaperProps={{ className: 'dde-result-dialog__paper' }}
            >
                {activeAlbResultDialog ? (
                    <>
                        <DialogTitle className="dde-result-dialog__title">
                            <Box className="dde-result-dialog__icon-wrap">
                                <activeAlbResultDialog.Icon className={activeAlbResultDialog.iconClassName} />
                            </Box>
                            <Typography variant="h6" className="dde-result-dialog__heading">
                                {activeAlbResultDialog.title}
                            </Typography>
                        </DialogTitle>
                        <DialogContent className="dde-result-dialog__content">
                            <DialogContentText>
                                <p className="dde-result-dialog__message">
                                    {activeResultMessage || activeAlbResultDialog.message}
                                </p>
                                {resultPopup === 'reject' && verifyRejectRemarks.length > 0 ? (
                                    <div className="reupload-api-remarks">
                                        <p className="reupload-api-remarks__heading">Document Remarks</p>
                                        <div className="reupload-api-remarks__list">
                                            {verifyRejectRemarks.map(({ label, remarks }, index) => (
                                                <div key={`${label}-${index}`} className="reupload-api-remarks__item">
                                                    <p className="reupload-api-remarks__label">{label}</p>
                                                    <p className="reupload-api-remarks__text">{remarks}</p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ) : null}
                                {activeAlbResultDialog.showBill ? (
                                    <Box className="dde-result-dialog__actions">
                                        <Button
                                            type="button"
                                            variant="outlined"
                                            className="dde-result-dialog__bill-btn"
                                            onClick={() => downloadBill(dialogRowData.referenceNo || dialogRowData.refNo)}
                                        >
                                            <DescriptionIcon className="dde-result-dialog__bill-icon" />
                                            Download Bill
                                        </Button>
                                    </Box>
                                ) : null}
                            </DialogContentText>
                        </DialogContent>
                    </>
                ) : null}
            </Dialog>

            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }
                }
                open={viewBackdrop}
            >
                <AppLoader />
            </Backdrop >

        </>
    )
});

export default AdjustLastBillTable;
